import React, { useState, useEffect, useRef } from 'react';
import { 
  FaTrash, FaEdit, FaPlus, FaSearch, FaFilter, 
  FaSave, FaTimes, FaWineBottle, FaChartBar, FaBox,
  FaChevronLeft, FaChevronRight,
  FaAngleLeft, FaAngleRight
} from 'react-icons/fa';
import { FiPackage } from "react-icons/fi";
import { 
  obtenerProductos, 
  agregarProducto as agregarProductoDB, 
  editarProducto as editarProductoDB, 
  eliminarProducto as eliminarProductoDB,
  cargarCategorias, getPrecioProducto,obtenerTotalProductos
} from './servicios/supabase-funciones';
import './AdminPanel.css';

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { scrollearSeccion } from './scrollear_seccion';

function AdminPanel() {
  const navigate = useNavigate();
  
  // Estados básicos - declarados PRIMERO
  const [categorias, setCategorias] = useState([]);
  const [productos, setProductos] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');
  
  // Estados para paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const [productosPorPagina] = useState(6);
  const [totalProductos, setTotalProductos] = useState(0);
  const [cargando, setCargando] = useState(false);

  // Estados del formulario
  const [formData, setFormData] = useState({
    nombre: '',
    categoria: '',
    detalle: '',
    precio: '',
    descripcion: '',
    stock: '',
    oferta: '0',
    recomendado: 'No',
    orden: '' // ← Agregar campo orden
  });
  const [fotos, setFotos] = useState([null, null]);
  const [vistasPrevias, setVistasPrevias] = useState([null, null]);
  const [editandoId, setEditandoId] = useState(null);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);

  // Estados para imágenes
  const [indicesImagenesCatalogo, setIndicesImagenesCatalogo] = useState({});
  const [transicionImagenCatalogo, setTransicionImagenCatalogo] = useState({});
  const [preciosProductos, setPreciosProductos] = useState({});

  // Estados para estadísticas
  const [stats, setStats] = useState({
    totalProductos: 0,
    valorInventario: 0,
  });

  const formularioRef = useRef(null);
  const productosRef = useRef(null);
  const productosMuestra = [];

  // Cargar categorías
  useEffect(() => {
    async function cargarDatosCategorias() {
      try {
        const lista = await cargarCategorias();
        if (!lista || lista.length === 0) {
          setCategorias(["Tintos", "Blancos", "Rosados", "Espumantes"]);
        } else {
          setCategorias(lista);
        }
      } catch (error) {
        setCategorias(["Tintos", "Blancos", "Rosados", "Espumantes"]);
      }
    }
    cargarDatosCategorias();
  }, []);

  // Cargar productos - EFECTO PRINCIPAL
  useEffect(() => {
    async function cargarProductos() {
      setCargando(true);
      try {
        // Usar la categoría del filtro para cargar productos específicos
        const categoriaParaFiltrar = filtroCategoria || null;
        const data = await obtenerProductos(paginaActual, productosPorPagina, categoriaParaFiltrar);
        
        if (!data || data.length === 0) {
          setProductos([]);
          setTotalProductos(0);
        } else {
          setProductos(data);
          // Obtener el total real de productos para la categoría
          const total = await obtenerTotalProductos(categoriaParaFiltrar);
          setTotalProductos(total);
        }
      } catch (err) {
        console.error("Error cargando productos:", err);
        setProductos([]);
        setTotalProductos(0);
      } finally {
        setCargando(false);
      }
    }
    cargarProductos();
  }, [paginaActual, filtroCategoria]);

  // Calcular estadísticas
  const calcularStats = (productosList) => {
    const total = productosList.length;
    const valorTotal = productosList.reduce((sum, p) => sum + (parseFloat(p.precio || 0) * parseInt(p.stock || 0)), 0);
    setStats({ 
      totalProductos: total, 
      valorInventario: valorTotal 
    });
  };

  useEffect(() => { 
    calcularStats(productos); 
  }, [productos]);

  // Resetear a página 1 cuando cambian los filtros
  useEffect(() => {
    setPaginaActual(1);
  }, [filtroCategoria, busqueda]);

  const manejarInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Manejar selección de archivo
  const manejarFotos = (e, index) => {
    const archivo = e.target.files?.[0];
    if (!archivo) return;

    if (!archivo.type.startsWith('image/')) {
      alert('Por favor selecciona un archivo de imagen válido');
      return;
    }

    const src = URL.createObjectURL(archivo);

    const nuevasFotos = [...fotos];
    nuevasFotos[index] = archivo;
    setFotos(nuevasFotos);

    const nuevasVistas = [...vistasPrevias];
    if (nuevasVistas[index] && nuevasVistas[index].startsWith('blob:')) {
      try { 
        URL.revokeObjectURL(nuevasVistas[index]); 
      } catch(e) {
        console.warn('Error al revocar URL:', e);
      }
    }
    nuevasVistas[index] = src;
    setVistasPrevias(nuevasVistas);
  };

  // Eliminar imagen
  const eliminarImagen = (index) => {
    if (vistasPrevias[index] && vistasPrevias[index].startsWith('blob:')) {
      try {
        URL.revokeObjectURL(vistasPrevias[index]);
      } catch(e) {
        console.warn('Error al revocar URL:', e);
      }
    }

    const nuevasVistas = [...vistasPrevias];
    nuevasVistas[index] = null;
    setVistasPrevias(nuevasVistas);

    const nuevasFotos = [...fotos];
    nuevasFotos[index] = null;
    setFotos(nuevasFotos);
  };

  // Reset form
  const resetForm = () => {
    setFormData({ 
      nombre: '', 
      categoria: '', 
      detalle: '',
      precio: '', 
      descripcion: '', 
      stock: '',
      oferta: '0',
      recomendado: 'No',
      orden: '' // ← Agregar aquí también
    });
    
    vistasPrevias.forEach((src, index) => {
      if (src && src.startsWith('blob:')) {
        try { 
          URL.revokeObjectURL(src); 
        } catch(e) {
          console.warn('Error al revocar URL en reset:', e);
        }
      }
    });
    
    setFotos([null, null]);
    setVistasPrevias([null, null]);
    setEditandoId(null);
    setMostrarFormulario(false);
  };

  // Guardar producto
  const agregarProducto = async (e) => {
    e.preventDefault();
    if (!formData.nombre || !formData.categoria || !formData.precio || !formData.stock) {
      alert('Por favor completa todos los campos obligatorios');
      return;
    }

    if (!fotos[0] && !vistasPrevias[0]) {
      alert('La imagen principal es obligatoria');
      return;
    }

    try {
      const productoData = {
        nombre: formData.nombre,
        categoria: formData.categoria,
        detalle: formData.detalle,
        precio: parseFloat(formData.precio) || 0,
        descripcion: formData.descripcion || '',
        stock: parseInt(formData.stock) || 0,
        oferta: parseFloat(formData.oferta) || 0,
        recomendado: formData.recomendado === 'Si',
        orden: parseInt(formData.orden) || 0 // ← FALTA ESTE CAMPO
      };

      let resultado;
      if (editandoId) {
        resultado = await editarProductoDB(editandoId, productoData, fotos);
        setProductos(productos.map(p => p.id === editandoId ? (resultado || { ...p, ...productoData }) : p));
      } else {
        resultado = await agregarProductoDB(productoData, fotos);
        setProductos(prev => [...prev, resultado || { id: Date.now(), ...productoData }]);
      }
      
      resetForm();
      setPaginaActual(1); // Resetear a primera página después de agregar/editar
      
      alert(editandoId ? 'Producto actualizado correctamente' : 'Producto agregado correctamente');
    } catch (error) {
      console.error('Error al guardar producto:', error);
      alert('Error al guardar producto: ' + (error.message || error));
    }
  };

  // Preparar para editar
  const editarProducto = (producto) => {
    setFormData({
      nombre: producto.nombre || '',
      categoria: producto.categoria || '',
      detalle: producto.detalle,
      precio: producto.precio || '',
      descripcion: producto.descripcion || '',
      stock: producto.stock || '',
      oferta: producto.oferta || producto.precio_oferta || '0',
      recomendado: producto.recomendado ? 'Si' : 'No',
       orden: producto.orden || '' // ← Cargar el orden del producto
    });

    const nuevasVistas = [
      producto.imagen_url || null,
      producto.imagen_url_2 || null
    ];
    
    vistasPrevias.forEach(src => {
      if (src && src.startsWith('blob:')) {
        try { 
          URL.revokeObjectURL(src); 
        } catch(e) {
          console.warn('Error al revocar URL en edición:', e);
        }
      }
    });

    setVistasPrevias(nuevasVistas);
    setFotos([null, null]);
    setEditandoId(producto.id);
    setMostrarFormulario(true);
    
    setTimeout(() => {
      scrollearSeccion("formulario-producto");
    }, 100);
  };
  // Obtener el próximo orden disponible
// Obtener el próximo orden disponible
const obtenerProximoOrdenDisponible = async () => {
  try {
    if (productos.length === 0) return 1;
    
    // Asegurarnos de que todos los productos tengan campo orden
    const productosConOrden = productos.filter(p => p.orden !== undefined && p.orden !== null);
    
    if (productosConOrden.length === 0) return 1;
    
    // Ordenar para obtener el máximo
    const maxOrden = Math.max(...productosConOrden.map(p => parseInt(p.orden) || 0));
    return maxOrden + 1;
  } catch (error) {
    console.error('Error obteniendo próximo orden:', error);
    return 1;
  }
};

// Usar en el efecto cuando se muestra el formulario para nuevo producto
useEffect(() => {
  const cargarProximoOrden = async () => {
    if (!editandoId && mostrarFormulario) {
      const proximoOrden = await obtenerProximoOrdenDisponible();
      setFormData(prev => ({
        ...prev,
        orden: proximoOrden.toString()
      }));
    }
  };
  
  cargarProximoOrden();
}, [mostrarFormulario, editandoId, productos]);
  // Eliminar producto
  const handleEliminarProducto = async (id) => {
    if (!window.confirm('¿Estás seguro de que querés eliminar este producto?')) return;
    try {
      await eliminarProductoDB(id);
      setProductos(productos.filter(p => p.id !== id));
      alert('Producto eliminado correctamente');
    } catch (err) {
      console.error(err);
      alert('Error eliminando producto');
    }
    if (productosActuales.length === 1 && paginaActual > 1) {
      setPaginaActual(paginaActual - 1);
    }
  };

  // ✅ SOLO filtro de búsqueda en frontend (la categoría ya se filtra en el backend)
  const productosFiltrados = productos.filter(p => {
    return p.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
           p.descripcion?.toLowerCase().includes(busqueda.toLowerCase()) ||
           p.detalle?.toLowerCase().includes(busqueda.toLowerCase());
  });

  // Usar los productos filtrados por búsqueda (sin paginación adicional)
  const productosActuales = productosFiltrados;

  // Calcular total de páginas basado en el total real de productos (no solo los filtrados por búsqueda)
  const totalPaginas = Math.ceil(totalProductos / productosPorPagina);

  // Cambiar página
  const cambiarPagina = (numeroPagina) => {
    setPaginaActual(numeroPagina);
  };

  // Funciones para el carrusel
  const cambiarImagenCatalogo = (productoId, direccion) => {
    setTransicionImagenCatalogo(prev => ({
      ...prev,
      [productoId]: `saliente ${direccion}`
    }));

    setTimeout(() => {
      setIndicesImagenesCatalogo(prev => {
        const currentIndex = prev[productoId] || 0;
        const producto = productos.find(p => p.id === productoId);
        
        if (!producto) return prev;
        
        const imagen1 = producto.imagen_url;
        const imagen2 = producto.image_url_2;
        const imagenesValidas = [imagen1, imagen2].filter(img => 
          img && typeof img === 'string' && img.trim() !== ''
        );
        
        const totalImagenes = imagenesValidas.length;
        
        if (totalImagenes <= 1) {
          return prev;
        }
        
        let nuevoIndex;
        if (direccion === 'next') {
          nuevoIndex = (currentIndex + 1) % totalImagenes;
        } else {
          nuevoIndex = (currentIndex - 1 + totalImagenes) % totalImagenes;
        }
        
        return {
          ...prev,
          [productoId]: nuevoIndex
        };
      });

      setTimeout(() => {
        setTransicionImagenCatalogo(prev => ({
          ...prev,
          [productoId]: `entrante ${direccion}`
        }));

        setTimeout(() => {
          setTransicionImagenCatalogo(prev => {
            const newState = { ...prev };
            delete newState[productoId];
            return newState;
          });
        }, 400);
      }, 50);
    }, 300);
  };

  const obtenerImagenActualCatalogo = (producto) => {
    if (!producto || typeof producto !== 'object') {
      return '/placeholder-image.jpg';
    }
    
    const index = indicesImagenesCatalogo[producto.id] || 0;
    const imagen1 = producto.imagen_url;
    const imagen2 = producto.image_url_2;
    
    const imagenes = [imagen1, imagen2].filter(img => 
      img && typeof img === 'string' && img.trim() !== ''
    );
    
    if (imagenes.length === 0) {
      return '/placeholder-image.jpg';
    }
    
    return imagenes[index] || imagenes[0];
  };

  const tieneMultiplesImagenes = (producto) => {
    if (!producto || typeof producto !== 'object') {
      return false;
    }
    
    const imagen1 = producto.imagen_url;
    const imagen2 = producto.image_url_2;
    
    const imagenesValidas = [imagen1, imagen2].filter(img => 
      img && typeof img === 'string' && img.trim() !== ''
    );
    
    return imagenesValidas.length > 1;
  };

  useEffect(() => {
    const cargarTodosLosPrecios = async () => {
      const preciosMap = {};
      for (const producto of productos) {
        try {
          const precioData = await getPrecioProducto(producto.id);
          preciosMap[producto.id] = precioData || { 
            precioNormal: producto.precio, 
            precioOferta: null, 
            enOferta: false 
          };
        } catch (error) {
          preciosMap[producto.id] = { 
            precioNormal: producto.precio, 
            precioOferta: null, 
            enOferta: false 
          };
        }
      }
      setPreciosProductos(preciosMap);
    };

    if (productos.length > 0) cargarTodosLosPrecios();
  }, [productos]);

  const PrecioProducto = ({ productoId }) => {
    const precioData = preciosProductos[productoId];

    if (!precioData) return <p className="product-price">-</p>;

    if (precioData.enOferta && precioData.precioOferta > 0) {
      return (
        <div className="precio-container">
          <div className="precios">
            <p className="product-price-tachado">${precioData.precioNormal}</p>
            <p>-</p>
            <p className="product-price-oferta">${precioData.precioOferta}</p>
          </div>
        </div>
      );
    }

    return (
      <div className="precio-container">
        <p className="product-price">${precioData.precioNormal}</p>
      </div>
    );
  };

  // ... (el resto de tu JSX permanece igual)

  return (
    <div className="admin-panel-container">
      {/* HEADER */}
      <header className="admin-panel-header">
        <div className="admin-panel-title">
          <FaWineBottle className="admin-title-icon" />
          <h1>Panel de Administración</h1>
        </div>
        <div className="admin-panel-actions">
          <button className="admin-btn-secondary" onClick={() => navigate("/")}>
            <FontAwesomeIcon icon={faHome} /> Volver
          </button>
          <button
            className="admin-btn-primary"
            onClick={() => {
              if (mostrarFormulario) {
                resetForm();
              } else {
                setMostrarFormulario(true);
                setTimeout(() => {
                  scrollearSeccion("formulario-producto");
                }, 150);
              }
            }}
          >
            <FaPlus />
            {mostrarFormulario ? "Cancelar" : "Nuevo Producto"}
          </button>
        </div>
      </header>

      {/* STATS */}
      <section className="admin-stats-grid">
        <div className="admin-stat-card">
          <FiPackage className="admin-stat-icon" />
          <div>
            <h3>{stats.totalProductos}</h3>
            <p>Total Productos</p>
          </div>
        </div>
        <div className="admin-stat-card">
          <FaChartBar className="admin-stat-icon" />
          <div>
            <h3>${stats.valorInventario.toLocaleString()}</h3>
            <p>Valor Inventario</p>
          </div>
        </div>
      </section>

     {/* FORM */}
      {mostrarFormulario && (
        <section id="formulario-producto" className="admin-form-section" ref={formularioRef}>
          <h2>{editandoId ? 'Editar Producto' : 'Agregar Nuevo Producto'}</h2>
          <form className="admin-product-form" onSubmit={agregarProducto}>
            <div className="admin-form-row">
              <div className="admin-form-group">
                <label>Nombre *</label>
                <input 
                  type="text" 
                  name="nombre" 
                  value={formData.nombre} 
                  onChange={manejarInputChange} 
                  required 
                />
              </div>
              <div className="admin-form-group">
                <label>Categoría *</label>
                <select 
                  name="categoria" 
                  value={formData.categoria} 
                  onChange={manejarInputChange} 
                  required
                >
                  <option value="">Seleccionar categoría</option>
                  {categorias.map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="admin-form-row">
              <div className="admin-form-group">
                <label>Precio ($) * </label>
                <input 
                  type="number" 
                  name="precio" 
                  value={formData.precio} 
                  onChange={manejarInputChange} 
                  min="0" 
                  step="0.01" 
                  required 
                />
              </div>

              <div className='admin-form-group'>
                <label>Precio de Oferta ($) * (Si no tiene Colocar 0)</label>
                <input
                  type='number'
                  name='oferta'
                  value={formData.oferta}
                  onChange={manejarInputChange}
                  required
                />
              </div>

              <div className='admin-form-group'>
                <label>Recomendado *</label>
                <select
                  name='recomendado'
                  value={formData.recomendado}
                  onChange={manejarInputChange}
                  required
                >
                  <option value="No">No</option>
                  <option value="Si">Sí</option>
                </select>
              </div>

              <div className="admin-form-group">
                <label>Stock *</label>
                <input 
                  type="number" 
                  name="stock" 
                  value={formData.stock} 
                  onChange={manejarInputChange} 
                  min="0" 
                  required 
                />
              </div>
              {/* NUEVO CAMPO: ORDEN */}
        <div className="admin-form-group">
          <label>Orden *</label>
          <input 
            type="number" 
            name="orden" 
            value={formData.orden} 
            onChange={manejarInputChange} 
            min="1" 
            required 
            placeholder="Número de orden"
          />
          <small className="form-help-text">
            Los productos se mostrarán según este número (menor número = primero)
          </small>
        </div>
      


            </div>
                    <div className="admin-form-group admin-full-width">
              <label>Detalle</label>
              <textarea 
                name="detalle" 
                value={formData.detalle} 
                onChange={manejarInputChange} 
                rows="3" 
                placeholder="Detalle Visible en el catalogo..."
              />
            </div>

            <div className="admin-form-group admin-full-width">
              <label className='Descripcion'>Descripción</label>
              <textarea 
                name="descripcion" 
                value={formData.descripcion} 
                onChange={manejarInputChange} 
                rows="3" 
                placeholder="Descripción del producto..."
              />
            </div>

            <div className="admin-form-group admin-full-width">
              <label >Imágenes del Producto</label>
              
              <div className="admin-image-upload-group">
                <label className='Descripcion'>Imagen Principal *</label>
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={(e) => manejarFotos(e, 0)} 
                />
                <div className="admin-image-actions">
                  {vistasPrevias[0] ? (
                    <>
                      <img src={vistasPrevias[0]} alt="Vista previa 1" className="admin-image-preview" />
                      <div className="admin-image-buttons">
                        <button type="button" className="admin-btn-small admin-btn-delete" onClick={() => eliminarImagen(0)}>
                         <FaTrash />
                        </button>
                      </div>
                    </>
                  ) : (
                    <p className="admin-image-placeholder">
                      {editandoId ? 'Usando imagen actual' : 'Aún no hay imagen'}
                    </p>
                  )}
                </div>
              </div>

              <div className="admin-image-upload-group">
                <label>Imagen Secundaria</label>
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={(e) => manejarFotos(e, 1)} 
                />
                <div className="admin-image-actions">
                  {vistasPrevias[1] ? (
                    <>
                      <img src={vistasPrevias[1]} alt="Vista previa 2" className="admin-image-preview" />
                      <div className="admin-image-buttons">
                        <button type="button" className="admin-btn-small admin-btn-delete" onClick={() => eliminarImagen(1)}>
                          <FaTrash />
                        </button>
                      </div>
                    </>
                  ) : (
                    <p className="admin-image-placeholder">
                      {editandoId ? 'Usando imagen actual' : 'Aún no hay imagen'}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="admin-form-actions">
              <button type="button" className="admin-btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="admin-btn-primary">
                <FaSave /> {editandoId ? 'Actualizar' : 'Agregar'}
              </button>
            </div>
          </form>
        </section>
      )}


      {/* FILTROS */}
      <section className="admin-filters-section">
        <div className="admin-search-box">
          <FaSearch className="admin-search-icon" />
          <input 
            type="text" 
            placeholder="Buscar por nombre o descripción..." 
            value={busqueda} 
            onChange={e => setBusqueda(e.target.value)} 
          />
        </div>
        <div className="admin-filter-box">
          <FaFilter className="admin-filter-icon" />
          <select 
            value={filtroCategoria} 
            onChange={e => setFiltroCategoria(e.target.value)}
          >
            <option value="">Todas las categorías</option>
            {categorias.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
      </section>
           
          
{cargando && (
  <div className="admin-loading">
    <p>Cargando productos...</p>
  </div>
)}

      {/* LISTA DE PRODUCTOS CON PAGINACIÓN */}
      <section id="lista-productos" className="admin-products-section" ref={productosRef}>
        <div className="catalogo-header">
          <h2>Productos ({productosFiltrados.length})</h2>
         <p>
  Mostrando {productosActuales.length} de {totalProductos} productos 
  {filtroCategoria && ` en categoría "${filtroCategoria}"`}
  {busqueda && ` filtrados por "${busqueda}"`}
  (página {paginaActual} de {totalPaginas})
</p>
        </div>

        <div className="product-grid-3-columns">
          {productosActuales.length === 0 ? (
            <div className="admin-empty-state">
              <FaBox className="admin-empty-icon" />
              <h3>No se encontraron productos</h3>
              <p>Intenta ajustar los filtros de búsqueda</p>
            </div>
          ) : (
            productosActuales.map((p) => {
              const imagenActual = obtenerImagenActualCatalogo(p);
              const multiplesImagenes = tieneMultiplesImagenes(p);

              return (
                <div key={p.id} id={`producto-${p.id}`} className="product-card" onClick={() => navigate(`/producto/${p.id}`)} style={{ cursor: "pointer" }}>
                  <div className="product-image-container">
                    <div className={`image-wrapper ${transicionImagenCatalogo[p.id] || ''}`}>
                      <img
                        src={imagenActual}
                        alt={p.nombre}
                        className="product-image"
                        onError={(e) => { e.target.src = '/placeholder-image.jpg'; }}
                      />

                      {multiplesImagenes && (
                        <>
                          <button 
                            className="carousel-btn left" 
                            onClick={(e) => { e.stopPropagation(); cambiarImagenCatalogo(p.id, 'prev'); }}
                          >
                            <FaChevronLeft />
                          </button>
                          <button 
                            className="carousel-btn right" 
                            onClick={(e) => { e.stopPropagation(); cambiarImagenCatalogo(p.id, 'next'); }}
                          >
                            <FaChevronRight />
                          </button>
                        </>
                      )}

                      <span className="product-badge">{p.categoria}</span>
                    </div>
                  </div>

                  <div className="product-info">
                    <h3 className="product-title">{p.nombre}</h3>
                     <span className="product-order-badge">Orden: {p.orden || 0}</span>
                    <p className="product-description">{p.detalle}</p>

                    <PrecioProducto productoId={p.id} />

                    <div className="product-meta">
                      <p className={`product-stock ${p.stock > 5 ? "in-stock" : "low-stock"}`}>
                        {p.stock > 5 ? "En stock" : "Últimas unidades"}
                      </p>
                    </div>

                    <div className="product-buttons">
                      <button
                        className="admin-btn-edit"
                        onClick={(e) => { e.stopPropagation(); editarProducto(p); }}
                      >
                        <FaEdit /> Editar
                      </button>
                      <button
                        className="admin-btn-delete"
                        onClick={(e) => { e.stopPropagation(); handleEliminarProducto(p.id); }}
                      >
                        <FaTrash /> Eliminar
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* PAGINACIÓN */}
        {totalPaginas > 1 && (
          <div className="admin-pagination">
            <button 
              className={`pagination-btn ${paginaActual === 1 ? 'disabled' : ''}`}
              onClick={() => cambiarPagina(paginaActual - 1)}
              disabled={paginaActual === 1}
            >
              <FaAngleLeft /> Anterior
            </button>
            
            <div className="pagination-numbers">
              {[...Array(totalPaginas)].map((_, index) => {
                const pagina = index + 1;
                // Mostrar solo páginas cercanas a la actual
                if (
                  pagina === 1 || 
                  pagina === totalPaginas || 
                  (pagina >= paginaActual - 1 && pagina <= paginaActual + 1)
                ) {
                  return (
                    <button
                      key={pagina}
                      className={`pagination-number ${paginaActual === pagina ? 'active' : ''}`}
                      onClick={() => cambiarPagina(pagina)}
                    >
                      {pagina}
                    </button>
                  );
                } else if (pagina === paginaActual - 2 || pagina === paginaActual + 2) {
                  return <span key={pagina} className="pagination-ellipsis">...</span>;
                }
                return null;
              })}
            </div>
            
            <button 
              className={`pagination-btn ${paginaActual === totalPaginas ? 'disabled' : ''}`}
              onClick={() => cambiarPagina(paginaActual + 1)}
              disabled={paginaActual === totalPaginas}
            >
              Siguiente <FaAngleRight />
            </button>
          </div>
        )}
      </section>
    </div>
  );
}

export default AdminPanel;


